module.exports = __webpack_public_path__ + "img/logo-takaful-umum.dd39fd49.png";